import { INFORMATION_SOURCE } from 'cpool-constants';
import { z } from 'zod';

import { schemaApplicantAttributionBoth, schemaBigDecimal, schemaId } from '../../../utils/schema.utils';

export const Leasing = z.object({
    createdAt: z.coerce.date().nullish(),
    datumLetzteRate: z.coerce.date().nullish().default(null),
    // warum wird hier ein richtiges date verwendet?
    gehoertZuAntragsteller: schemaApplicantAttributionBoth,
    glaeubiger: z.string().nullish().default(null),
    id: schemaId,
    rateMonatlich: schemaBigDecimal.nullish().default(null),
    schlussrate: schemaBigDecimal.nullish().default(null),
    source: z.nativeEnum(INFORMATION_SOURCE).optional().default(INFORMATION_SOURCE.FORMULAR),
    zinssatz: schemaBigDecimal.nullish().default(null),
});

// INFO yup schema
//                         yup.object().shape({
//                             datumLetzteRate: yup.date().optional().nullable().default(null),
//                             gehoertZuAntragsteller: yup
//                                 .string()
//                                 .oneOf(['ANTRAGSTELLER_1', 'ANTRAGSTELLER_2', 'BEIDE'])
//                                 .required(),
//                             glaeubiger: yup.string().optional().nullable().default(null),
//                             id: yup.string(),
//                             rateMonatlich: yup.number().optional().nullable().default(null),
//                             schlussrate: yup.number().optional().nullable().default(null),
//                             source: yup.string().oneOf(['FORMULAR', 'SCHUFA']).optional().default('FORMULAR'),
//                         }),
